var map = {
  "./cs.messages.tsx": [
    "20852",
    [
      8598
    ]
  ],
  "./en.messages.tsx": [
    "90985",
    [
      1321
    ]
  ],
  "./sl.messages.tsx": [
    "49609",
    [
      4301
    ]
  ],
  "./hu.messages.tsx": [
    "46017",
    [
      3925
    ]
  ],
  "./de.messages.tsx": [
    "45309",
    [
      3425
    ]
  ],
  "./it.messages.tsx": [
    "76103",
    [
      8027
    ]
  ],
  "./pl.messages.tsx": [
    "7478",
    [
      444
    ]
  ],
  "./sk.messages.tsx": [
    "52156",
    [
      2542
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 88321;
module.exports = __rspack_async_context;
